import type { ImgHTMLAttributes } from 'react';
import { useCallback, useEffect, useState } from 'react';
import VehiclePlaceholderSvg from '../../assets/blankVehicle.svg';

interface VehicleImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    'data-testid'?: string;
}

const VehicleImage = ({ src, ...rest }: VehicleImageProps) => {
    const [isImageError, setIsImageError] = useState(false);

    // Reset the image error state when the src changes
    useEffect(() => setIsImageError(false), [src]);
    const onImageError = useCallback(() => {
        setIsImageError(true);
    }, []);

    const imageSrc = src && !isImageError ? src : VehiclePlaceholderSvg;
    const dataTestId = rest['data-testid'] || 'vehicle-image';

    return <img {...rest} src={imageSrc} onError={onImageError} data-testid={dataTestId} />;
};

export default VehicleImage;
